import { Expose } from "class-transformer";

export class CreateOnCallTypeDto {
  @Expose()
  name: string;

  @Expose()
  excludesWorkableMissingHours = true;

  @Expose()
  isWorkableOnSaturday = false;
}
